import cx from 'classnames';

import {Button} from '#component/base';
import {Transition} from '#component/util';
import {useViewportSize} from '#hook';

import {StoryControlsProps} from './StoryControls.types';

import * as css from './StoryControls.css';

/**
 * A component used in the `ResultsStory` route, which renders the
 * "forward" and "back" buttons used in most steps of the story.
 *
 * The icons used for these buttons are unique and rendered inline, and are not
 * part of the "phosphor" library used by the `Icon` base component.
 */
export const StoryControls = ({
  className = '',
  nextDisabled,
  onNext,
  onPrevious,
  onShare,
  previousDisabled,
  shareVisible,
  variant = 'primary',
  ...otherProps
}: StoryControlsProps) => {
  const {isMobile, isDesktop} = useViewportSize();
  return (
    <Transition appear className={cx(className, css.root)} {...otherProps} as="div">
      <button
        aria-label="Go to previous step"
        className={css.button({variant})}
        disabled={previousDisabled}
        onClick={onPrevious}>
        <svg aria-hidden viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
          <path d="M2.008 19.412h37.404a.588.588 0 0 1 0 1.176H2.008l4.29 4.29a.589.589 0 0 1-.831.832L.172 20.416a.588.588 0 0 1 0-.832l5.295-5.294a.589.589 0 0 1 .831.832l-4.29 4.29z" />
        </svg>
      </button>

      {!isDesktop && (
        <Transition className={css.shareButton} show={shareVisible}>
          <Button icon="ShareNetwork" onClick={onShare} variant="primary-dark">
            {isMobile ? 'Share' : 'Share your results'}
          </Button>
        </Transition>
      )}

      <button
        aria-label="Go to next step"
        className={css.button({variant})}
        disabled={nextDisabled}
        onClick={onNext}>
        <svg aria-hidden viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
          <path d="M37.992 19.412H.588a.588.588 0 0 0 0 1.176h37.404l-4.29 4.29a.589.589 0 0 0 .832.832l5.294-5.294a.588.588 0 0 0 0-.832l-5.294-5.294a.589.589 0 0 0-.832.832l4.29 4.29z" />
        </svg>
      </button>
    </Transition>
  );
};
